import {Typography, Grid, Tooltip, Accordion, AccordionDetails, AccordionSummary} from '@mui/material';

import {Fragment} from 'react';
import {faCheck, faXmark} from '@fortawesome/free-solid-svg-icons';
import {faCaretRight} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

/**
 * AllPlansDropdown component for rendering an accordion with plan details.
 *
 * @component
 * @param {Object} props - The properties of the component.
 * @param {string} props.title - The title of the accordion.
 * @param {Array} props.descriptionsData - Array of objects containing descriptions and plan values.
 * @returns {JSX.Element} The AllPlansDropdown component.
 */
export const AllPlansDropdown = ({title, descriptionsData}) => {
  const firstTextGridSpace = 5;
  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        backgroundColor: 'transparent',
        boxShadow: 'none',
        borderRadius: '0 !important',
        '&.Mui-expanded:not(:first-of-type):before': {
          opacity: 1,
          display: 'block !important',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<FontAwesomeIcon icon={faCaretRight} style={{color: '#000', fontSize: 16}} />}
        sx={{
          px: 2,
          boxShadow: 'none',
          flexDirection: 'row-reverse',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
            marginRight: 1,
          },
          '& .MuiAccordionSummary-content': {
            marginLeft: 1,
          },
        }}
      >
        <Typography fontSize={20} fontWeight={700}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid
          container
          sx={{
            gap: {
              xs: 1,
              md: 4,
            },
            justifyContent: 'space-between',
          }}
        >
          {descriptionsData.map((value, idx) => {
            const iconValues = {
              check: faCheck,
              xmark: faXmark,
            };
            return (
              <Fragment key={idx}>
                <Grid item xs={7} md={firstTextGridSpace}>
                  <Tooltip
                    title={<Typography>{value.tooltip}</Typography>}
                    placement="top"
                    sx={{
                      width: 'fit-content',
                      textDecoration: 'underline',
                      textDecorationStyle: 'dashed',
                      textUnderlineOffset: '.3em',
                      marginLeft: {
                        xs: 1,
                        md: 4,
                      },
                    }}
                  >
                    <Typography>{value.description}</Typography>
                  </Tooltip>
                </Grid>
                {Object.keys(value.planValues).map((plan, idx1) => {
                  const planValue = value.planValues[plan];
                  const theIcon = iconValues[planValue];
                  const totalPlans = Object.keys(value.planValues).length;
                  let gridSize = (12 - firstTextGridSpace) / totalPlans - 1;

                  return (
                    <Fragment key={`${idx}${idx1}`}>
                      <Grid
                        item
                        xs={3}
                        md={gridSize}
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <FontAwesomeIcon icon={theIcon} />
                      </Grid>
                    </Fragment>
                  );
                })}
              </Fragment>
            );
          })}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
